import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface SectionHeaderProps {
  icon: LucideIcon;
  children: React.ReactNode;
  className?: string;
  /** Render as semantic heading when used for top-level sections (e.g. "Growth over time") */
  as?: "div" | "h2";
}

/** Small section label with icon for visual polish */
export function SectionHeader({
  icon: Icon,
  children,
  className,
  as: Component = "div",
}: SectionHeaderProps) {
  return (
    <Component
      className={cn(
        "mb-3 flex items-center gap-2 text-muted-foreground",
        className
      )}
    >
      <Icon className="size-4 shrink-0" aria-hidden />
      <span className="text-xs font-medium uppercase tracking-wider">
        {children}
      </span>
    </Component>
  );
}
